import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { withVersion } from 'tofe-core';

/**
 * Appends `?v=<build id>` to requests for runtime assets (translations, customization JSON,
 * welcome HTML, ...) so that a deploy produces new URLs and browsers do not serve old copies
 * from their cache. Which URLs qualify is decided by the compiled-in rules in `tofe-core`
 * (`ASSET_CACHE_RULES`); API requests and anything cross-origin are left untouched.
 */
@Injectable()
export class AssetVersionInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = withVersion(request.url);
    return next.handle(url === request.url ? request : request.clone({ url }));
  }
}

export const AssetVersionInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AssetVersionInterceptor,
  multi: true,
};
